import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {CreateUserInput, useCreateUserMutation} from '../../graphql';
import {ErrorView} from '../GraphQL/ErrorView';
import {UserNewContainer} from './container';
import {CombinedError} from 'urql';

export const UserNewGraphQL = () => {
  const history = useHistory();
  const [error, setError] = useState<CombinedError | undefined>();
  const [createUserResult, createUserPromise] = useCreateUserMutation();
  const createUser = (values: CreateUserInput) => {
    createUserPromise({input: {...values}}).then((result) => {
      if (result.error) {
        return setError(result.error);
      }
      history.replace('/user/edit/' + result?.data?.createUser?.result?.id);
    });
  }

  return (
    <ErrorView fetching={false} errors={[error]}>
      <UserNewContainer createUser={createUser}/>
    </ErrorView>
  );
};
